/**
 * Read tracker - Monitors article reading progress via GA events
 */

const getLocation = (href) => {
	let l = document.createElement("a");
	l.href = href;
	return l;
};

const path = getLocation(window.location.href).pathname;
const startime = localStorage.getItem(path) ? parseInt(localStorage.getItem(path)) : 0;
let reported = false;

// Cache layout measurements to reduce forced reflows
let cachedMeasurements = null;

const cacheMeasurements = () => {
	let body = document.body;
	let html = document.documentElement;
	let y = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
	let w = window;
	let d = document;
	let e = d.documentElement;
	let g = d.getElementsByTagName('body')[0];
	let x = w.innerWidth || e.clientWidth || g.clientWidth;
	let z = w.innerHeight || e.clientHeight || g.clientHeight;
	
	let querySelectorVar = document.querySelector('[id^=discussion],[id=shareBottom],#comments,#commentarea,[name=comments],[class^=comment_form],[class^=entry-comments],.FBComments,fb\\:comments,div[id^=coment],#forum,[id^=disqus_thread],#related-content,#RelatedPostsContainer,.post-latest,#notas-rel,div[class=post-footer],div[class=morearticles],footer');
	let fullArticleheight = parseInt(y);
	if (querySelectorVar) {
		fullArticleheight = parseInt(querySelectorVar.offsetTop) - parseInt(z);
	}
	
	cachedMeasurements = { y, x, z, fullArticleheight };
};

// Recalculate measurements on resize — only registered when the tracker is active.
let resizeTimeout;
const attachResizeListener = () => {
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			requestAnimationFrame(cacheMeasurements);
		}, 250);
	});
};

const readerTracker = (readtime) => {
	let timeinterval = 2000;
	// Measurements are primed by startTracking() before readerTracker() is called.
	
	let wheretolook = document.getElementsByTagName('body')[0] ? 'body' : 'html';
	// var textbrut = document.getElementsByTagName(wheretolook)[0].innerHTML ? document.getElementsByTagName(wheretolook)[0].innerHTML.replace(/<!--[\s\S]*?-->/g, '').replace(/\<(script|noscript|style|form|header|footer|nav)[\s\S]*?\>.*?\<\/(script|noscript|style|form|header|footer|nav)\>/g, '').replace(/\<.*?\>/g, '').replace(/\&nbsp\;/g, ' ').replace(/\s+/g, ' ') : '';

    let textbrut = document.querySelector('.article__content') ? document.querySelector('.article__content').innerHTML : '';
    textbrut = textbrut.replace(/<!--[\s\S]*?-->/g, '');
    textbrut = textbrut.replace(/<(script|noscript|style|form|header|footer|nav)[\s\S]*?\>.*?<\/(script|noscript|style|form|header|footer|nav)\>/g, '');
    textbrut = textbrut.replace(/<.*?\>/g, '');
    textbrut = textbrut.replace(/\&nbsp\;/g, ' ');
    textbrut = textbrut.replace(/\s+/g, ' ');

	let readingtime = textbrut.split(' ').length / 330;
	let pathname = getLocation(window.location.href).pathname + '?read=true';
	let intervalreading;

    window.onblur = () => {
		if (intervalreading) {
			clearInterval(intervalreading);
			intervalreading = null;
		}
	};

    window.onfocus = () => {
		readerTracker(readtime);
	};

    window.onbeforeunload = () => {
		try {
			localStorage.setItem(path, readtime);
		} catch (ev) {
			console.log("Storage failed: " + ev);
		}
	};

    if (!reported) {
		intervalreading = setInterval(function() {
			readtime = parseInt(readtime) + parseInt(timeinterval);
			// Use window.scrollY which doesn't cause reflow
			let scrollTop = window.scrollY || window.pageYOffset;
			// Use cached measurements instead of reading layout properties
			let fullArticleheight = cachedMeasurements.fullArticleheight;

			if (readtime / 60000 >= parseInt(readingtime) * 0.75 && scrollTop >= fullArticleheight * 0.85) {
				// Track article read completion using GA4
				window?.ST?.analytics?.trackEvent?.('Article read completion', {
					pathname: pathname,
					readTime: Math.round(readtime / 60000) + ' minutes',
					scrollPercentage: Math.round((scrollTop / fullArticleheight) * 100) + '%'
				});
				
				clearInterval(intervalreading);
				intervalreading = null;
				reported = true;
				try {
					localStorage.setItem(path, 0);
				} catch (ev) {
					console.log("Storage failed: " + ev);
				}
			}
		}, timeinterval);
	}
};

const startTracking = () => {
	// Only run on article pages — avoids a polling setInterval on every page.
	if (!document.querySelector('.article__content')) {
		return;
	}

	attachResizeListener();

	// Prime layout measurements inside rAF so all styles are applied before
	// we read offsetTop/scrollHeight, avoiding a forced synchronous reflow.
	requestAnimationFrame(() => {
		cacheMeasurements();
		if (document.hasFocus()) {
			readerTracker(startime);
		} else {
			window.onfocus = function() {
				readerTracker(startime);
			};
		}
	});
};

export default {
    startTracking
};
